import { ItemCard } from '../../components/ItemCard';
import type { SpaDayCardProps } from './SpaDayCard.types';

const defaultFormatGuests = (count: number) => `${count} ${count === 1 ? 'guest' : 'guests'}`;

function buildMeta(
  duration: string | undefined,
  numberOfGuests: number | undefined,
  formatGuests: (count: number) => string
): string {
  const meta: string[] = [];
  if (duration) meta.push(duration);
  if (numberOfGuests && numberOfGuests > 0) {
    meta.push(formatGuests(numberOfGuests));
  }
  return meta.join(' \u00B7 ');
}

export function SpaDayCard({
  id,
  name,
  imageUrl,
  price,
  discount,
  duration,
  numberOfGuests,
  unavailable,
  fromPriceLabel = 'From',
  soldOutLabel = 'Sold out',
  noImageLabel = 'No image',
  formatGuests = defaultFormatGuests,
  onSelect,
}: SpaDayCardProps) {
  const meta = buildMeta(duration, numberOfGuests, formatGuests);

  return (
    <ItemCard
      image={{ src: imageUrl, alt: name, placeholderLabel: noImageLabel }}
      title={name}
      meta={meta || undefined}
      statusBadge={unavailable ? soldOutLabel : undefined}
      price={
        !unavailable && price
          ? {
              amount: price.amount,
              currencyCode: price.currencyCode,
              label: fromPriceLabel,
              discount,
            }
          : undefined
      }
      unavailable={unavailable}
      ariaLabel={name}
      onSelect={() => onSelect(id)}
    />
  );
}
